import React from 'react';

//import images
import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";

//import Components
import LanguageDropdown from '../Components/LanguageDropdown';
import MyCartDropdown from '../Components/MyCartDropdown';
import ProfileDropdown from '../Components/ProfileDropdown';
import SettingsDropdown from '../Components/SettingsDropdown';

import { useSelector } from "react-redux";
import { Link } from 'react-router-dom';

const Header = ({ onChangeLayoutMode, layoutModeType, onChangeFontSize, currentFontSize, headerClass }) => {
  const user = useSelector(state => state?.user?.currentUser);

  const toogleMenuBtn = () => {
    var windowSize = document.documentElement.clientWidth;
    if (windowSize > 767)
      document.querySelector(".hamburger-icon").classList.toggle('open');

    if (windowSize < 1025 && windowSize > 767) {
      document.body.classList.remove('vertical-sidebar-enable');
      (document.documentElement.getAttribute('data-sidebar-size') === 'sm') ? document.documentElement.setAttribute('data-sidebar-size', '') : document.documentElement.setAttribute('data-sidebar-size', 'sm');
    } else if (windowSize > 1025) {
      document.body.classList.remove('vertical-sidebar-enable');
      (document.documentElement.getAttribute('data-sidebar-size') === 'lg') ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg');
    } else if (windowSize <= 767) {
      document.body.classList.add('vertical-sidebar-enable');
      document.documentElement.setAttribute('data-sidebar-size', 'lg');
    }
  };

  return (
    <React.Fragment>
      <header id="page-topbar" className={headerClass}>
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">

              <div className="navbar-brand-box horizontal-logo">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logoSm} alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoDark} alt="" height="17" />
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logoSm} alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoLight} alt="" height="17" />
                  </span>
                </Link>
              </div>

              <button
                onClick={toogleMenuBtn}
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none"
                id="topnav-hamburger-icon">
                <span className="hamburger-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
            </div>

            <div className="d-flex align-items-center">

              <LanguageDropdown />
              {((user?.permissions && user?.permissions.includes('shop')) || user?.role === "admin" || user?.role === "client") &&
                <MyCartDropdown />
              }
              <SettingsDropdown
                layoutMode={layoutModeType}
                onChangeLayoutMode={onChangeLayoutMode}
                currentFontSize={currentFontSize}
                onChangeFontSize={onChangeFontSize}
              />
              <ProfileDropdown />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
